import styled from "styled-components";
import { space, SpaceProps, LayoutProps, layout } from "styled-system";
import css from "@styled-system/css";

export interface DividerProps extends SpaceProps, LayoutProps {
  /**
   The divider orientation. Accepts the following values: horizontal and vertical. Note: vertical works inside a flex container only.
   */
  orientation?: "horizontal" | "vertical";
  /**
   Custom css to be applied.
   */
  css?: string;
}

const StyledDivider = styled.hr<DividerProps & { css?: string }>`
  box-sizing: border-box;
  border: none;
  ${css({
    backgroundColor: "divider-color",
  })}
  ${space}
  ${layout}
  ${(props) => props.css}
`;

export default function Divider({
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  css,
  width = "auto",
  orientation = "horizontal",
  ...props
}: DividerProps) {
  return (
    <StyledDivider
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      css={css}
      width={width}
      height={orientation === "horizontal" ? "1px" : "auto"}
      {...props}
    ></StyledDivider>
  );
}
